import { render } from "./FileUploadSuccessModal.vue?vue&type=template&id=425b1ac1"
import script from "./FileUploadSuccessModal.vue?vue&type=script&lang=js"
export * from "./FileUploadSuccessModal.vue?vue&type=script&lang=js"
script.render = render

export default script